import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import user from "./Modules/User/UserModule";
import filters from "./Modules/Filters/FiltersModule";
import categories from "./Modules/Categories/CategoriesModule";
import globalLabels from "./Modules/GlobalLabels/GlobalLabelsModule";
import itemPriceHistory from "./Modules/ItemPriceHistory/ItemPriceHistoryModule";
import branding from "./Modules/Branding/BrandingModule";

Vue.use(Vuex);

/*
 * CONFIG FOR VUEX PERSIST
 * key: "vuex", / The key to store the state on in the storage provider.
 * storage: window.localStorage, / or window.sessionStorage or localForage
 * Function that passes the state and returns the state with only the objects you want to store.
 * reducer: (state) => ({products: state.products}),
 * Function that passes a mutation
 * and lets you decide if it should update the state in localStorage.
 * filter: mutation => (true)
 */
const vuexLocalStorage = new VuexPersist({

		/*
		 * Modules to persist - do not write your own reducer if you want to use this!
		 *
		 * On logout, the storage gets wiped out by src/services/session.js:clearStorage();
		 * if you need some data to persist between logouts, update the clearStorage() function.
		 */
		modules: [ "user", "filters", "guestCount", "branding" ]
	}),
	state = {},
	mutations = {},
	actions = {},
	getters = {},
	modules = {
		user,
		filters,
		categories,
		globalLabels,
		itemPriceHistory,
		branding,
	},
	plugins = [vuexLocalStorage.plugin];

export default new Vuex.Store({
	state,
	mutations,
	actions,
	getters,
	modules,
	plugins
});
